var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        thumbnail: _vm.renderType == "THUMBNAIL",
        "thumbnail-listitem": _vm.renderType == "LIST",
        pointer: _vm.addClick,
      },
      on: { click: _vm.doClick },
    },
    [
      _vm.isLoading
        ? [_c("loader")]
        : [
            _vm.renderType == "LIST"
              ? [
                  _vm.showPreview && _vm.sourceUrl
                    ? _c("div", { staticClass: "image" }, [
                        _c("div", {
                          staticClass: "image-box",
                          style: {
                            backgroundImage: `url(${_vm.sourceUrl})`,
                          },
                        }),
                      ])
                    : _c(
                        "span",
                        { staticClass: "icon type" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.faIcon },
                          }),
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _vm.properties
                    ? _c(
                        "span",
                        { staticClass: "properties" },
                        _vm._l(_vm.properties, function (prop, i) {
                          return _c(
                            "span",
                            { key: `prop_${i}`, staticClass: "tag mx5-xs" },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(prop.value) +
                                  "\n                "
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "name" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.title) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._t("default"),
                ]
              : _vm.renderType == "THUMBNAIL"
              ? [
                  _vm.showPreview && _vm.sourceUrl
                    ? [
                        _c(
                          "div",
                          { staticClass: "image" },
                          [
                            _vm.fileType == "IMAGE"
                              ? [_c("img", { attrs: { src: _vm.sourceUrl } })]
                              : _vm.fileType == "VIDEO"
                              ? [
                                  _c("video", {
                                    attrs: {
                                      preload: "",
                                      autoplay: "1",
                                      muted: "",
                                      src: _vm.sourceUrl,
                                    },
                                    domProps: { muted: true },
                                  }),
                                ]
                              : _vm.fileType == "PDF"
                              ? [
                                  _c("responsiveIframe", {
                                    attrs: { src: _vm.sourceUrl },
                                  }),
                                ]
                              : _vm.fileType == "TXT"
                              ? [
                                  _c("responsiveIframe", {
                                    attrs: { src: _vm.sourceUrl },
                                  }),
                                ]
                              : [
                                  _c(
                                    "span",
                                    { staticClass: "icon type" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: _vm.faIcon },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                            _vm._v(" "),
                            _vm.properties
                              ? _c(
                                  "span",
                                  { staticClass: "properties" },
                                  _vm._l(_vm.properties, function (prop, i) {
                                    return _c(
                                      "span",
                                      {
                                        key: `prop_${i}`,
                                        staticClass: "tag mx5-xs",
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(prop.value) +
                                            "\n                        "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    : [
                        _c(
                          "span",
                          { staticClass: "icon type" },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: _vm.faIcon },
                            }),
                          ],
                          1
                        ),
                      ],
                  _vm._v(" "),
                  _c("div", { staticClass: "actions" }, [_vm._t("default")], 2),
                ]
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }